// src/pages/super-admin/reports/UploadReport.tsx

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { formatUsDate } from "@/utils/date";
import { toast } from "sonner";

export default function UploadReport() {
  const [client, setClient] = useState("");
  const [user, setUser] = useState("");
  const [test, setTest] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [date, setDate] = useState("");

  const handleUpload = () => {
    console.log({
      client,
      user,
      test,
      date,
      file,
    });

    toast.success("Report uploaded!");
  };

  return (
    <div className="space-y-4 p-4">
      <select
        className="border p-2 rounded w-full"
        value={client}
        onChange={(e) => setClient(e.target.value)}
      >
        <option value="">Select Client</option>
        <option value="1">Medicare Staffing</option>
      </select>

      <select
        className="border p-2 rounded w-full"
        value={user}
        onChange={(e) => setUser(e.target.value)}
      >
        <option value="">Select User</option>
        <option value="1">John Carter</option>
      </select>

      <select
        className="border p-2 rounded w-full"
        value={test}
        onChange={(e) => setTest(e.target.value)}
      >
        <option value="">Select Test</option>
        <option value="5-panel">5 Panel Drug Test</option>
        <option value="10-panel">10 Panel Drug Test</option>
      </select>

      <Input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
      />
      <p className="text-xs text-slate-500">
        Format: MM-DD-YYYY{date ? ` (Selected: ${formatUsDate(date)})` : ""}
      </p>

      <Input
        type="file"
        accept="application/pdf"
        onChange={(e) => setFile(e.target.files?.[0] || null)}
      />

      <div className="flex justify-end">
        <Button onClick={handleUpload}>Upload</Button>
      </div>
    </div>
  );
}
